import { useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import hero1 from "../../assets/images/DreamHouse1.jpg";
import hero2 from "../../assets/images/Construction2.jpg";
import hero3 from "../../assets/images/DesignDiagram.jpg";
import hero4 from "../../assets/images/DreamHouse2.jpg";

import "./HeroCarousel.css";

export default function HeroCarousel() {
  const [loadedImages, setLoadedImages] = useState({});

  const images = [hero1, hero2, hero3, hero4];

  const handleImageLoad = (index) => {
    setLoadedImages((prev) => ({ ...prev, [index]: true }));
  };

  return (
    <div className="hero-carousel">
      <Carousel
        autoPlay
        infiniteLoop
        showThumbs={false}
        showStatus={false}
        interval={3500}
        transitionTime={800}
      >
        {images.map((img, index) => (
          <div className="carousel-slide" key={index}>
            {!loadedImages[index] && <div className="image-loader"></div>}

            <img
              src={img}
              alt={`Slide ${index + 1}`}
              onLoad={() => handleImageLoad(index)}
              className={loadedImages[index] ? "loaded-img" : "loading-img"}
            />

            <div className="carousel-text">
              {index === 0 && (
                <>
                  <h2>Building Your Dreams</h2>
                  <p>
                    High-quality construction services with trusted expertise.
                  </p>
                </>
              )}
              {index === 1 && (
                <>
                  <h2>Strong Foundations</h2>
                  <p>Reliable, durable, and modern architectural solutions.</p>
                </>
              )}
              {index === 2 && (
                <>
                  <h2>We Build With Passion</h2>
                  <p>
                    Your vision transformed into reality by our expert team.
                  </p>
                </>
              )}
              {index === 3 && (
                <>
                  <h2>Trusted by Hundreds</h2>
                  <p>Delivering excellence in every project we undertake.</p>
                </>
              )}
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  );
}
